import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/delete-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: [],            
    failure: ["error"],     
    reset: [],              
  },
  { prefix: "RESTORE_USER_" }
);

export interface RestoreUserState extends IState {}

const INITIAL_STATE: RestoreUserState = {
  loading: false,
  error: null,
};

const request = (state: RestoreUserState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: RestoreUserState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: RestoreUserState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const restoreUser = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const RestoreUserTypes = Types;
export const RestoreUserActions = Creators;
